import css from '@styled-system/css'
import * as React from 'react'
import styled, { StyledComponent, ThemeContext } from 'styled-components'
import {
  color,
  ColorProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system'

const SvgIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    size?: number | string
    color?: string
  },
) => {
  const { size } = props

  if (size != null) {
    props = {
      width: size,
      height: size,
      ...props,
    }
  }

  const themeContext = React.useContext(ThemeContext)

  if (props.color != null) {
    props = { ...props, color: themeContext.colors[props.color] || props.color }
  }

  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#settings_svg__clip0)" fill={props.color || '#000'}>
        <path d="M81.598 33.973l-6.036-1.024a34.084 34.084 0 00-2.426-5.856l3.558-4.977a5.297 5.297 0 00-.575-6.845l-5.354-5.353a5.274 5.274 0 00-3.755-1.563 5.22 5.22 0 00-3.072.988L58.944 12.9a33.736 33.736 0 00-6.072-2.497l-1.006-5.965A5.307 5.307 0 0046.62.001h-7.564a5.307 5.307 0 00-5.245 4.437l-1.042 6.109a33.235 33.235 0 00-5.84 2.46l-4.94-3.556a5.274 5.274 0 00-3.09-.988c-1.419 0-2.766.557-3.754 1.563l-5.372 5.353a5.318 5.318 0 00-.575 6.845l3.593 5.048a33.287 33.287 0 00-2.39 5.875l-5.964 1.006A5.307 5.307 0 000 39.399v7.563a5.307 5.307 0 004.437 5.246l6.109 1.042a33.25 33.25 0 002.46 5.839L9.469 64.01a5.297 5.297 0 00.575 6.845l5.353 5.353a5.273 5.273 0 003.755 1.563 5.22 5.22 0 003.072-.988l5.048-3.593a33.99 33.99 0 005.677 2.336l1.006 6.036A5.307 5.307 0 0039.2 86h7.581a5.307 5.307 0 005.246-4.437l1.024-6.036a34.087 34.087 0 005.857-2.426l4.976 3.558a5.274 5.274 0 003.09.988c1.42 0 2.749-.557 3.755-1.563l5.354-5.354a5.318 5.318 0 00.575-6.845L73.1 58.891a33.835 33.835 0 002.426-5.857l6.036-1.006A5.307 5.307 0 0086 46.782V39.22c.035-2.605-1.833-4.815-4.402-5.246zm-.413 12.81a.465.465 0 01-.395.466l-7.546 1.258a2.412 2.412 0 00-1.94 1.779 28.759 28.759 0 01-3.126 7.527c-.485.826-.45 1.85.108 2.64l4.437 6.253a.49.49 0 01-.054.61l-5.353 5.354a.456.456 0 01-.342.144.441.441 0 01-.27-.09l-6.233-4.437a2.427 2.427 0 00-2.641-.108 28.762 28.762 0 01-7.527 3.126 2.385 2.385 0 00-1.779 1.94l-1.276 7.545a.465.465 0 01-.467.396h-7.563a.465.465 0 01-.467-.396l-1.258-7.545a2.412 2.412 0 00-1.778-1.94 29.863 29.863 0 01-7.366-3.018 2.487 2.487 0 00-1.221-.324c-.486 0-.989.144-1.402.45l-6.288 4.473a.535.535 0 01-.27.09.482.482 0 01-.34-.144l-5.354-5.354a.487.487 0 01-.054-.61l4.42-6.198a2.46 2.46 0 00.107-2.66 28.487 28.487 0 01-3.162-7.509 2.46 2.46 0 00-1.94-1.778l-7.6-1.294a.465.465 0 01-.394-.467v-7.563c0-.234.161-.431.395-.467l7.491-1.258a2.429 2.429 0 001.958-1.797 28.735 28.735 0 013.073-7.545 2.398 2.398 0 00-.126-2.623l-4.473-6.288a.49.49 0 01.053-.61l5.354-5.354a.457.457 0 01.341-.144.44.44 0 01.27.09l6.198 4.42a2.46 2.46 0 002.659.107 28.49 28.49 0 017.51-3.162 2.46 2.46 0 001.778-1.94l1.293-7.6a.465.465 0 01.467-.394h7.564c.233 0 .43.161.467.395l1.257 7.491a2.43 2.43 0 001.797 1.959c2.713.682 5.3 1.742 7.707 3.161.826.486 1.85.45 2.64-.107l6.199-4.456c.09-.054.18-.09.27-.09.071 0 .215.018.34.144l5.354 5.354c.162.162.18.413.054.61l-4.437 6.234a2.428 2.428 0 00-.108 2.641 28.76 28.76 0 013.126 7.528 2.384 2.384 0 001.94 1.778l7.546 1.276a.465.465 0 01.395.467v7.563h-.018z" />
        <path d="M43.009 24.433c-10.24 0-18.558 8.318-18.558 18.558S32.769 61.55 43.009 61.55s18.558-8.318 18.558-18.558-8.318-18.558-18.558-18.558zm0 32.266c-7.563 0-13.708-6.145-13.708-13.708 0-7.563 6.145-13.707 13.708-13.707 7.563 0 13.707 6.144 13.707 13.707 0 7.563-6.144 13.708-13.707 13.708z" />
      </g>
      <defs>
        <clipPath id="settings_svg__clip0">
          <path fill="#fff" d="M0 0h86v86H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

type StyledSystemProps = TypographyProps &
  SpaceProps &
  LayoutProps &
  ColorProps &
  PositionProps

const _style = (
  component: React.FC,
): StyledComponent<
  React.FC<
    React.SVGProps<SVGSVGElement> & {
      size?: number | string
      color?: string
    }
  >,
  Record<string, unknown>,
  StyledSystemProps,
  never
> => {
  const styledSystemProps = [typography, space, layout, color, position]
  return styled(component)(css({}), styledSystemProps)
}

const SvgSettings = _style(SvgIcon)

export default SvgSettings
